import React from 'react';

function CustomerPostalCode({
                              sendData, setSendData, initialData, componentData, setComponentData,
                            }) {
  return (<div className={"solid-dyna-input"}>
    <label htmlFor="">کد پستی</label>
    <input
      placeholder={"کد پستی "}
      value={sendData?.customerPostalCode ? sendData?.customerPostalCode : ""}
      onChange={e=> {
        setSendData({customerPostalCode:e.target.value})
      }}
    />
  </div>);
}

export default CustomerPostalCode;